// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zXhkw","question":"styles_question__UmiS5","description":"styles_description__MnHEX"};